
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRefundDetailsGrid extends Serenity.EntityGrid<ECommRefundDetailsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommRefundDetails'; }
        protected getDialogType() { return ECommRefundDetailsDialog; }
        protected getIdProperty() { return ECommRefundDetailsRow.idProperty; }
        protected getInsertPermission() { return ECommRefundDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommRefundDetailsRow.localTextPrefix; }
        protected getService() { return ECommRefundDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}